(function(window, document) {
    const shortDes = {
        init() {
            shortDes.create();
        },
        create() {
            var desc = $('[data-short-description]'), max = 280;
            if(desc.length == 0) return;

            checkMore();

            function checkMore() {
                desc.each(function() {
                    var seft = $(this),
                        txtMore = (seft.data('txt-more') || 'Xem thêm'),
                        txtLess = (seft.data('txt-less') || 'Thu gọn'),
                        name = seft.data('name'),
                        str = String(seft.find('[data-html]').html()).replace(/(<([^>]+)>)/ig, ''),
                        str_tmp = String(seft.find('[data-html]').html()).replace(/(<([^>]+)>)/ig, ''),
                        tot = str.length,
                        link,
                        max = parseInt(seft.data('max-length'));

                    if(tot <= max) {
                        str = str;
                        link = false;
                        seft.find('.link').remove();

                    } else {
                        str = str.substring(0,(max + 1))+"...";
                        
                        link = $('<span class="link w-black" data-short-element data-name="'+ name +'"><span class="txt">'+ txtMore +'</span><span class="icon-arrow-right-op2"></span></span>');
                        link.on('click', function(event) {
                            event.preventDefault();
                            var n = $(this).data('name');
                            if($(this).hasClass('on')) {
                                $('[data-short-description][data-name="'+ n +'"]').find('[data-copy]').html(str);
                                $(this).removeClass('on');
                                $(this).find('.txt').text(txtMore);
                            } else {
                                $('[data-short-description][data-name="'+ n +'"]').find('[data-copy]').html(str_tmp);
                                $(this).addClass('on');
                                $(this).find('.txt').text(txtLess);
                            }
                        });
                    }

                    seft.find('[data-copy]').html(str);
                    seft.append(link);
                });
            }
        }
    }

    window.jQuery(document).ready(function() {
        shortDes.init();
    });
})(window, document);